export const BT_BUTTON_LABELS = {
  BTN_LOGIN_TITLE: 'Sign In',
  BTN_SIGN_UP_HEAR: 'Sign up here',
  BTN_REMEMBER: 'Remember me',
  BTN_SIGN_IN: 'Sign in',
  BTN_GOOGLE: 'Sign in with Google',
  BTN_ADD_LEAVE: 'Add Leave Balance',
  BTN_ADD_ASSETS: 'Add Assets',
  BTN_ADD_ASSETS_FIELD: 'Add Assets Field',
  BTN_APPLY_LEAVE: 'Apply Leave',
  BTN_DONE: 'Done',
  BTN_SAVE: 'Save',
  BTN_UPDATE: 'Update',
  BTN_ACCEPT: 'Accept',
  BTN_REJECT: 'Reject',
  BTN_NEW_LEAVE_TYPE: 'New Leave Type',
  BTN_PLEASE_WAIT: 'Please Wait',
  BTN_ADD_HOLIDAY: 'Add Holidays',
  BTN_ADD_DEPARTMENT: 'Add Department',
  BTN_ADD_EMPLOYEE: 'Add Employee',
  BTN_ADD_DESIGNATION: 'Add Designation',
  BTN_UPLOAD: 'Upload',
  BTN_ADD_ANNOUNCEMENT: 'Add Announcement',
  BTN_UPDATE_ANNOUNCEMENT: 'Update Announcement',
  BTN_CANCEL: 'Cancel',
  BTN_DELETE: 'Delete',
  BTN_ADD_NOTE: 'Add Note',
  BTN_UPDATE_NOTE: 'Update Note',
  BTN_ADD_SUPPORT_TICKET: 'Add Support Ticket',
  BTN_ADD_COMPLAIN: 'Add Complaint',
  BTN_ADD_NEW_KPI: 'Add New KPI',
  BTN_ADD_LOP_OVERTIME_REQUEST: 'Add Request',
  BTN_RAISE_OVERTIME_REQUEST: 'Raise Overtime Request',
  BTN_RAISE_LOP_REQUEST: 'Raise LOP Request',
  BTN_NEXT: 'Next',
  BTN_PREVIOUS: 'Previous'
};
